import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import Container from '../components/Container'
import FaqParagraph from '../components/FaqParagraph'
import { usePageTitle } from '../hooks/toolkit'

const FaqPage = () => {
  const { t } = useTranslation()
  usePageTitle('FAQ | Agami')
  return (
    <Container direction="col">
      <Typography variant="h1" className="mb-12">
        {t('faq.title')}
      </Typography>

      <FaqParagraph id="account-faq" title={t('faq.account.title')} text={t('faq.account.text')} />

      <FaqParagraph id="code-faq" title={t('faq.code.title')} text={t('faq.code.text')} />

      <FaqParagraph id="spot-faq" title={t('faq.spot.title')} text={t('faq.spot.text')} />

      <FaqParagraph
        id="headphones-faq-1"
        title={t('faq.headphones1.title')}
        text={t('faq.headphones1.text')}
      />

      <FaqParagraph
        id="headphones-faq-2"
        title={t('faq.headphones2.title')}
        text={t('faq.headphones2.text')}
      />

      <FaqParagraph id="cloud-faq" title={t('faq.cloud.title')} text={t('faq.cloud.text')} />

      <FaqParagraph id="position-faq" title={t('faq.position.title')} text={t('faq.position.text')} />

      <FaqParagraph id="bch-faq" title={t('faq.bch.title')} text={t('faq.bch.text')} />
    </Container>
  )
}

export default FaqPage
